export const MEDIA_VAULT_UNREACHABLE_TYPE = 'https://yocoolmate.com/errors/media-vault-unreachable';

export const MEDIA_VAULT_UNREACHABLE_TITLE = 'Media vault unavailable';

export const MEDIA_VAULT_UNREACHABLE_LABEL = 'Snow Titan is offline';

export const CLOUDFLARE_ORIGIN_ERROR_STATUSES: readonly number[] = [
  520, 521, 522, 523, 524, 525, 526, 527, 530,
];
